export const CodeBlock = ({ code }) => {
  return (
    <div>
      <div className="company-green-box rounded-top" style={{ textAlign: "right" }}>
        <button className="copy rounded" data-clipboard-target="#codeBlock">
          Copy To Clipboard
        </button>
      </div>
      <div className="dark-box rounded-bottom" style={{ position: "relative" }}>
        <pre id="codeBlock">{code}</pre>
      </div>
    </div>
  );
};
